var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterGuideHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 1a6 6 0 1 1 0 12A6 6 0 0 1 7 1zm0 1.05a4.95 4.95 0 1 0 0 9.9 4.95 4.95 0 0 0 0-9.9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.2 3.418.918-.918 8.082 8.082-.918.918z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.319 5.319c2.36-2.36 5.093-3.453 6.104-2.442 1.011 1.011-.082 3.744-2.442 6.104-2.36 2.36-5.093 3.453-6.104 2.442-1.011-1.011.082-3.744 2.442-6.104zm5.361-1.7c-.429-.429-2.627.45-4.619 2.442-1.991 1.992-2.87 4.19-2.441 4.62.429.429 2.627-.45 4.619-2.442 1.991-1.992 2.87-4.19 2.441-4.62z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterGuideHome);
export default __webpack_public_path__ + "static/media/icon-filter-guide-home.39b4f242374ab633863add8509d710b2.svg";
export { ForwardRef as ReactComponent };